"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5603],{

/***/ 67623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ fetchBoards; }
/* harmony export */ });
/* unused harmony export ViewSetBoard */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchBoards = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Data) === null || ref2 === void 0 ? void 0 : ref2.rows
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBoards(body) {
        return _ref.apply(this, arguments);
    };
}();
var ViewSetBoard = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ViewSetBoard(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 63820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  .disabled {\n    .page-link {\n      opacity: 0;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-0"
})(_templateObject());
var MobilePaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-1"
})(_templateObject1());
function NoticePagination(param) {
    var prev = param.prev, currentPage = param.currentPage, getPaginationGroup = param.getPaginationGroup, next = param.next, pages = param.pages, nextEnd = param.nextEnd, prevStart = param.prevStart, handleActive = param.handleActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prevStart,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prev,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onClick: function() {
                                        return handleActive(item);
                                    },
                                    className: currentPage == item ? "page-item active" : "page-item",
                                    style: {
                                        zIndex: 5
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "page-link",
                                        children: item
                                    })
                                }, index);
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: next,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: nextEnd,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobilePaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage == 1)) {
                                        prev();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage == 1) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "page-item active",
                                style: {
                                    zIndex: 5
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: currentPage
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage >= pages)) {
                                        next();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage >= pages) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NoticePagination);


/***/ }),

/***/ 8837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91085);





var BlogList = function(param) {
    var blogList = param.blogList;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var moveToDetail = function(id) {
        router.push("/esg-guide/post/".concat(id));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: blogList === null || blogList === void 0 ? void 0 : blogList.map(function(item, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_4__/* .ArticleBox */ .LV, {
                className: "col-xl-4 col-lg-6 col-md-6 text-center hover-up mb-30 animated",
                onClick: function() {
                    return moveToDetail(item.id);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/esg-guide/post/".concat(item.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_4__/* .Thumbnail */ .pl, {
                            className: "",
                            thumbnail: item.thumbnail,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: item.thumbnail,
                                    alt: "tumbnail"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_4__/* .InfoBox */ .vD, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                    className: "post-title mb-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "/esg-guide/post/".concat(item.id),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: item.title
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK, {
                                className: "mb-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: "/esg-guide/post/".concat(item.id),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "entry-meta text-secondary",
                                        children: item.sub_title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "entry-meta font-xs color-grey mt-10 pb-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "post-on mr-10",
                                        children: item.wdate
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogList);


/***/ }),

/***/ 91085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "LV": function() { return /* binding */ ArticleBox; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "e_": function() { return /* binding */ GridList; },
/* harmony export */   "pl": function() { return /* binding */ Thumbnail; },
/* harmony export */   "vD": function() { return /* binding */ InfoBox; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  @media screen and (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow: hidden;\n  & img {\n    max-height: 400px;\n    height: auto;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  word-break: keep-all;\n  @media screen and (max-width: 991px) {\n    & h5 {\n      font-size: 18px;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    & h5 {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  word-wrap: break-word;\n  @media screen and (max-width: 991px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  .pagination {\n    justify-content: center !important;\n  }\n\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  justify-content: center;\n  width: 100%;\n\n  .pagination {\n    justify-content: center !important;\n  }\n\n  .disabled {\n    .page-link {\n      opacity: 0;\n    }\n  }\n\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-c1d591ab-0"
})(_templateObject());
var GridList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c1d591ab-1"
})(_templateObject1());
var ArticleBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    componentId: "sc-c1d591ab-2"
})(_templateObject2());
var InfoBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c1d591ab-3"
})(_templateObject3());
var Thumbnail = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c1d591ab-4"
})(_templateObject4());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c1d591ab-5"
})(_templateObject5());
var SubTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-c1d591ab-6"
})(_templateObject6());
var PaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c1d591ab-7"
})(_templateObject7());
var MobilePaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c1d591ab-8"
})(_templateObject8());


/***/ }),

/***/ 15603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91085);
/* harmony import */ var _Esg_guide_blog_list__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8837);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36968);
/* harmony import */ var _hook_esg_guide_useBoardListQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43785);
/* harmony import */ var _components_csboard_notice_notice_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63820);







var EsgGuideBlog = function(param) {
    var blogMenu = param.blogMenu, searchParams = param.searchParams, page = param.page, pageRows = param.pageRows, onPageChange = param.onPageChange;
    // boardName 결정
    var boardName = blogMenu === 0 ? "package" : "make";
    var adjustedPageRows = boardName === "package" || boardName === "make" ? 12 : pageRows || 12;
    // 데이터 가져오기
    var ref = (0,_hook_esg_guide_useBoardListQuery__WEBPACK_IMPORTED_MODULE_4__/* .useBoardListQuery */ .H)({
        boardName: boardName,
        keyword: (searchParams === null || searchParams === void 0 ? void 0 : searchParams.searchTerm) || "",
        page: page || 1,
        pageRow: adjustedPageRows
    }), tmp = ref.data, blogData = tmp === void 0 ? {
        items: [],
        totalCount: 0,
        totalPages: 0
    } : tmp, blogLoading = ref.isLoading, error = ref.error;
    // 구조 분해 할당으로 데이터 추출
    var blogList = blogData.items, totalCount = blogData.totalCount, totalPages = blogData.totalPages;
    // 페이지네이션 그룹 계산
    var getPaginationGroup = function() {
        var start = Math.floor(((page || 1) - 1) / 5) * 5;
        return new Array(Math.min(5, totalPages - start)).fill().map(function(_, idx) {
            return start + idx + 1;
        });
    };
    // 사용자 정의 handleActive 함수 - 페이지 변경 처리도 함께 수행
    var customHandleActive = function(pageNumber) {
        var activeClass = (page || 1) === pageNumber ? "active" : "";
        // 페이지 변경 호출
        onPageChange(pageNumber);
        return activeClass;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            blogLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "d-flex align-items-center justify-content-center",
                    style: {
                        minHeight: "500px"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        animation: "border",
                        role: "status"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-lg-12",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Esg_guide_blog_styles__WEBPACK_IMPORTED_MODULE_1__/* .GridList */ .e_, {
                            children: blogList && blogList.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Esg_guide_blog_list__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                blogList: blogList
                            }) : !blogLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-center py-5",
                                style: {
                                    gridColumn: "1 / -1"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
                                })
                            })
                        }),
                        blogList && blogList.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-100 d-flex justify-content-center mt-30 mb-30",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_csboard_notice_notice_pagination__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        prev: function() {
                                            return onPageChange((page || 1) - 1);
                                        },
                                        currentPage: page || 1,
                                        getPaginationGroup: getPaginationGroup(),
                                        next: function() {
                                            return onPageChange((page || 1) + 1);
                                        },
                                        pages: totalPages,
                                        nextEnd: function() {
                                            return onPageChange(totalPages);
                                        },
                                        prevStart: function() {
                                            return onPageChange(1);
                                        },
                                        handleActive: customHandleActive
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-none d-md-flex align-items-center ml-10",
                                        children: [
                                            page || 1,
                                            " / ",
                                            totalPages
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EsgGuideBlog);


/***/ }),

/***/ 43785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useBoardListQuery; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51586);
/* harmony import */ var _api_boards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67623);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var useBoardListQuery = function(param) {
    var boardName = param.boardName, keyword = param.keyword, page = param.page, pageRow = param.pageRow;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.ESG.BOARDS.INDEX */ .U.ESG.BOARDS.INDEX(boardName),
            keyword,
            page,
            pageRow
        ],
        queryFn: _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "List",
                            boardName: boardName,
                            keyword: keyword,
                            page: page,
                            page_rows: pageRow
                        };
                        _ctx.next = 3;
                        return (0,_api_boards__WEBPACK_IMPORTED_MODULE_2__/* .fetchBoards */ .P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!(res.code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            items: res.data.data,
                            totalCount: res.data.total_count,
                            totalPages: res.data.total_page
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            items: [],
                            totalCount: 0,
                            totalPages: 0
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
};


/***/ })

}]);